
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "payments-ui-app",
  currentProjectVersion: "static-1.28730",
  depVersions: {
  "payments-ui-app": "static-1.28730",
  "bend-plugin-arboretum": "static-1.2034",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.512",
  "crm_data": "static-4.93233",
  "data-fetching-client": "static-1.10127",
  "emoji-mart": "static-3.7",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8771",
  "foundations-components-legacy": "static-1.1796",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6080",
  "hs-test-utils": "static-1.8527",
  "hub-http": "static-1.6694",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11975",
  "I18n": "static-7.1709",
  "jasmine-runner": "static-1.6941",
  "quartz": "static-1.7683",
  "raven": "static-3.5925",
  "react-dlb": "static-1.94",
  "react-dnd": "static-2.33",
  "react-dnd-html5-backend": "static-2.10",
  "react-stripe-js": "static-1.121",
  "react-utils": "static-2.5667",
  "reselect": "static-3.16",
  "stripe-js": "static-1.120",
  "ui-components-test-utils": "static-1.6112",
  "UIComponents": "static-3.8921",
  "usage-tracker-public": "static-1.7622",
  "apollo-stack-hubspot": "static-3.94",
  "commerce-subscription-lib": "static-1.38080",
  "payments-checkout-lib": "static-1.653",
  "cssUtils": "static-1.1111",
  "customer-data-objects": "static-1.8195",
  "FireAlarmUi": "static-1.4878",
  "foundations-assets": "static-1.5376",
  "foundations-theming": "static-1.4978",
  "graphql": "static-1.93",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12282",
  "icons": "static-2.704",
  "isMobile": "static-1.7",
  "metrics-js": "static-1.9990",
  "PatternValidationJS": "static-1.3372",
  "property-translator": "static-1.5868",
  "quartz-config": "static-1.1461",
  "quartz-core": "static-1.6902",
  "quartz-i18n": "static-1.1358",
  "quartz-routing": "static-1.1113",
  "quartz-tracking": "static-1.1062",
  "react": "static-7.203",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17227",
  "react-select-plus": "static-1.118",
  "react-virtualized": "static-2.112",
  "redux": "static-4.81",
  "redux-thunk": "static-2.84",
  "redux-toolkit": "static-1.82",
  "ReduxMessenger": "static-2.10858",
  "rpc-client-utils": "static-1.5157",
  "sanitize-text": "static-1.8646",
  "SharedI18nStrings": "static-1.188",
  "styled-components": "static-2.100",
  "StyleGuideUI": "static-3.518",
  "superstore": "static-1.5247",
  "transmute": "static-2.97",
  "ui-addon-i18n": "static-1.11633",
  "ui-images": "static-2.1278",
  "usage-tracker-core": "static-1.7661",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3960",
  "quartz-webpack": "static-1.3907",
  "bend-plugin-quartz-routing": "static-1.761",
  "bender-build-tools": "static-1.3604",
  "crm_universal": "static-1.22747",
  "customer-data-email": "static-1.18663",
  "customer-data-ui-utilities": "static-1.10320",
  "dispatcher": "static-1.148",
  "frontend-preferences-client": "static-1.8410",
  "general-store": "static-6.20",
  "native-integrations-shared-strings": "static-1.8251",
  "quick-fetch": "static-1.4238",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5040",
  "floating-ui": "static-1.68",
  "foundations-theming-specialty": "static-1.2694",
  "framer-motion": "static-1.84",
  "hs-story-utils": "static-1.9917",
  "react-aria": "static-1.77",
  "react-create-root-preference": "static-1.105",
  "tanstack-table": "static-1.66",
  "trellis-assets": "static-1.3122",
  "ui-fonts": "static-1.1237",
  "HeadJS": "static-2.824",
  "hs-test-utils-bend-plugin": "static-1.3638",
  "msw": "static-1.103",
  "msw-config": "static-1.30",
  "testing-library": "static-1.165",
  "hs-locale-management": "static-1.409",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.235",
  "moment-timezone": "static-5.96",
  "jasmine": "static-4.4794",
  "foundations-components-test-utils": "static-1.6254",
  "ui-addon-draggable": "static-3.5237",
  "commerce-billing-lib": "static-1.20519",
  "commerce-shared-components-lib": "static-1.19597",
  "commerce-tools-ui-lib": "static-1.11346",
  "crm-message-bus": "static-1.44137",
  "customer-data-objects-ui-components": "static-1.13524",
  "customer-data-properties": "static-1.53097",
  "growth-payments-core": "static-1.26527",
  "ui-addon-iframeable": "static-1.9566",
  "usage-tracker": "static-1.7811",
  "usage-tracker-container": "static-1.7801",
  "sassPrefix": "static-1.376",
  "inbound-db-properties-service-client": "static-1.4158",
  "foundations-theming-base": "static-1.3963",
  "bend-plugin-foundations-theming": "static-1.3461",
  "stylex": "static-1.46",
  "opentelemetry-fe-types": "static-1.279",
  "hub-http-janus": "static-1.908",
  "hubspotter-http": "static-1.4982",
  "mobile-manifest-mixins": "static-1.607",
  "module-federation": "static-1.39",
  "opentelemetry-fe": "static-1.654",
  "quartz-auth": "static-1.1358",
  "quartz-head": "static-1.1348",
  "quartz-test": "static-1.1358",
  "trellis-components": "static-1.3141",
  "usage-tracker-session-replay": "static-1.5497",
  "csstype": "static-1.50",
  "beacon-keepalive-queue": "static-1.188",
  "web-vitals": "static-1.19",
  "immer": "static-1.105",
  "bend-plugin-chirp-manifest": "static-1.567",
  "chirp-fetch": "static-1.2393",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4963",
  "FormUrlGenerator": "static-2.5202",
  "sequences-lib": "static-1.8809",
  "apollo-link-hub-http": "static-2.5077",
  "FileManagerCore": "static-1.40361",
  "FileManagerLib": "static-1.40502",
  "hubspot-apollo-client": "static-1.5371",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "salesImages": "static-1.746",
  "timezone-utils": "static-2.5719",
  "ui-gdpr-components": "static-1.10656",
  "react-dnd-compat": "static-1.5098",
  "stylex-utils": "static-1.176",
  "trellis-theming": "static-1.1502",
  "react-flip-move": "static-1.83",
  "avatar-components": "static-1.2975",
  "hs-resources": "static-1.672",
  "pulse": "static-1.1137",
  "utility-belt": "static-1.3026",
  "zustand": "static-1.89",
  "batch-promise": "static-1.2037",
  "customer-data-associations": "static-1.7826",
  "customer-data-property-utils": "static-1.8540",
  "customer-data-tracking": "static-1.7360",
  "framework-data-schema-resolvers": "static-1.7381",
  "framework-data-table": "static-2.12862",
  "object-builder-ui-client": "static-1.50083",
  "payments-enrollment-embed-lib": "static-1.24241",
  "stripe-embedded-components": "static-1.8268",
  "ui-addon-opt": "static-4.8902",
  "ai-components-ui-library": "static-1.10048",
  "customer-data-rte": "static-1.33925",
  "cv-backend-services": "static-1.1607",
  "file-manager-components": "static-1.24862",
  "growth-onboarding-confetti": "static-1.3546",
  "growth-onboarding-empty-states": "static-1.6555",
  "hubspot-prosemirror": "static-1.19306",
  "InboxConnectUtils": "static-4.15866",
  "payment-link-components": "static-1.24482",
  "payments-post-enroll-local-storage-lib": "static-1.5594",
  "prosemirror": "static-1.13",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39195",
  "react-colorpicker": "static-2.10698",
  "ui-addon-upgrades": "static-9.18554",
  "ui-addon-video-player": "static-1.9111",
  "user-context": "static-1.5542",
  "restore-request-side-panel-lib": "static-1.2053",
  "atom": "static-1.5560",
  "reference-resolvers": "static-1.8673",
  "calling-global-api": "static-1.66230",
  "calling-internal-common": "static-1.31813",
  "calling-lifecycle-internal": "static-1.67612",
  "calling-lifecycle-messages": "static-1.59904",
  "commerce-products-lib": "static-1.10944",
  "conditional-properties-service-client": "static-1.4120",
  "crm-index-visualization-core": "static-1.4777",
  "crm-links": "static-1.6801",
  "crm-pipelines-api-client-types": "static-1.4451",
  "customer-data-properties-shared-msw-handlers": "static-1.10253",
  "data-agent-utils": "static-1.955",
  "external-options-client-types": "static-1.4446",
  "formula-editor": "static-1.15028",
  "google-libphonenumber": "static-1.50",
  "inbound-db-meta-service-client": "static-1.3782",
  "inbounddb-objects-service-types": "static-1.4522",
  "meetings-icalendar-utils-lib": "static-1.1120",
  "multi-currency-client-types": "static-1.4015",
  "pipeline-validation-client-types": "static-1.4290",
  "property-value-citations": "static-1.3711",
  "reference-resolvers-lite": "static-1.8601",
  "smart-data-capture-core": "static-1.511",
  "tiered-pricing": "static-1.2306",
  "topics-actions-lib": "static-1.672",
  "trellis-ext-i18n": "static-1.1408",
  "trial-components-library": "static-1.14404",
  "ui-addon-form-validation": "static-1.11348",
  "laboratory-lib": "static-3.7635",
  "onboarding-scopes": "static-1.6942",
  "seat-types-lib": "static-1.1071",
  "magpie-lib": "static-1.5918",
  "navigation-messaging": "static-1.8524",
  "ts-schema": "static-1.4402",
  "opentelemetry-web": "static-1.23",
  "hub-http-shared-msw-handlers": "static-1.10926",
  "hubspotter-http-shared-msw-handlers": "static-1.10924",
  "base-ui": "static-1.29",
  "react-day-picker": "static-1.15",
  "tanstack-virtual": "static-1.43",
  "amplitude-session-replay-browser": "static-1.60",
  "sequences-client-types-lib": "static-1.8666",
  "audio-components": "static-1.6592",
  "breeze-artifacts-sdk": "static-1.1028",
  "ContentUtils": "static-1.69507",
  "copilot-toolkit": "static-1.12177",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.30081",
  "FileManagerImages": "static-1.38013",
  "html-to-image": "static-1.65",
  "immerable": "static-1.4630",
  "ui-universal-auth": "static-1.9768",
  "urlinator": "static-1.5002",
  "video-components": "static-1.14470",
  "video-data-lib": "static-1.36126",
  "video-embed": "static-1.36960",
  "hubspot-apollo-cache": "static-1.830",
  "trellis-migration-context": "static-1.69",
  "event-emitter": "static-1.1450",
  "fdsr-migration-layer": "static-1.500",
  "framework-builder-read-service-client": "static-1.4342",
  "bend-plugin-pulse": "static-1.640",
  "fast-json-patch": "static-1.74",
  "framework-data-schema-quick-fetch": "static-1.7286",
  "persist-promise": "static-1.4194",
  "customer-data-reference-ui-components": "static-1.13662",
  "reporting-data": "static-1.69400",
  "tasks-actions-lib": "static-1.459",
  "purchase-motions-components": "static-1.6650",
  "growth-onboarding-feedback-components": "static-1.7069",
  "growth-onboarding-reliability": "static-1.5572",
  "marketplace-ui-apps-core": "static-1.19582",
  "onboarding-tours": "static-1.17411",
  "stripe-connect-js": "static-1.83",
  "chatspot-core": "static-1.23966",
  "content-assistance-lib": "static-1.8442",
  "draft-content-plugins": "static-1.29179",
  "draft-convert": "static-2.84",
  "draft-extend": "static-3.88",
  "draft-js": "static-5.90",
  "draft-plugins": "static-2.22380",
  "rich-text-lib": "static-1.20576",
  "breeze-engine-lib": "static-1.2233",
  "poll-commands": "static-1.3966",
  "video-components-external": "static-1.12468",
  "trellis-story-utils": "static-1.4986",
  "ui-addon-react-router-dom": "static-1.10013",
  "content-media-capture": "static-1.5817",
  "knowledge-content-types": "static-1.8767",
  "ui-addon-emoji-picker": "static-1.10351",
  "ui-business-units-lib": "static-1.9585",
  "ui-shepherd-react": "static-3.10768",
  "hub-http-contrib": "static-1.3521",
  "ui-addon-sales-email": "static-1.5690",
  "commerce-tours-lib": "static-1.6881",
  "getting-started-shared-tasks": "static-1.19589",
  "sales-checkout-service-client": "static-1.4009",
  "merchandise-lib": "static-1.286",
  "getting-started-shared-tasks-store": "static-1.18707",
  "onboarding-tours-utils": "static-1.1478",
  "calling-error-reporting": "static-1.31820",
  "shared-worker-versioning": "static-1.11532",
  "calling-usage-tracker": "static-1.7029",
  "conversations-skeleton-state": "static-1.7609",
  "voice-sms-access-library": "static-1.2492",
  "commerce-permissions": "static-1.1274",
  "products-iframe-lib": "static-1.8942",
  "products-ui-components-shared-msw-handlers": "static-1.11308",
  "crm-index-associations-lib": "static-1.6936",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11009",
  "sales-views-client-types": "static-1.4747",
  "location-customization-utils-lib": "static-1.10446",
  "data-agent-kit": "static-1.942",
  "enrichment-settings-lib": "static-1.257",
  "fsm": "static-1.4246",
  "markdown-it": "static-1.6",
  "policy-lib": "static-1.7292",
  "bark-lib": "static-1.17022",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.106",
  "crm-properties-common-lib": "static-1.6385",
  "react-codemirror": "static-1.11130",
  "embedded-academy-lib": "static-1.16043",
  "hubs-service-types": "static-1.1756",
  "navigation-components": "static-1.19197",
  "nest": "static-1.724",
  "nudge-client-utils": "static-1.3444",
  "purchase-motions-api": "static-1.6653",
  "signup-constants": "static-1.19970",
  "idb-keyval": "static-1.55",
  "magpie-types": "static-1.5378",
  "reactive-lib": "static-1.1209",
  "simple-logging-lib": "static-1.3539",
  "nav-meta": "static-1.30834",
  "breeze-engine-core": "static-1.1511",
  "cms-field-types": "static-1.5298",
  "content-icons-ui": "static-1.2470",
  "integrations-lib": "static-1.17459",
  "underscore": "static-1.8",
  "custom-vendor-connection-lib": "static-1.332",
  "unified-auth-core-lib": "static-1.1564",
  "social-insights-client-types": "static-1.22954",
  "outpost": "static-1.4617",
  "reporting-client-types": "static-1.2848",
  "signup-ui-url-generator": "static-2.8526",
  "developer-experience-shared-components": "static-1.11029",
  "immutable-less": "static-1.5140",
  "marketplace-ui-client-types": "static-1.18457",
  "marketplace-ui-common": "static-1.21050",
  "ui-addon-integrations-directory-panel": "static-2.8442",
  "ui-extensibility-client-types": "static-1.4403",
  "growth-data-modal": "static-1.6155",
  "growth-onboarding-next-action-utils": "static-1.3010",
  "onboarding-tours-client": "static-1.5626",
  "ui-shepherd-tracker": "static-1.8149",
  "ui-coaching-tips": "static-1.29597",
  "data-token-picker": "static-1.17156",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1211",
  "highlight.js": "static-1.90",
  "content-media-composition-data-lib": "static-1.13621",
  "content-media-compositions": "static-2.17628",
  "media-bridge-lib": "static-1.19662",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4917",
  "calling-orchestration-schema": "static-1.37269",
  "crm-record-cards-service-types": "static-1.3871",
  "highcharts": "static-8.115",
  "storybook-react": "static-1.44",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16692",
  "browser-eslint": "static-2.57",
  "academy-common-lib": "static-1.15504",
  "nudge-custom-function-registry": "static-1.3201",
  "nudge-renderer-utils": "static-1.3520",
  "whisper-core-api": "static-1.7663",
  "flux-actions": "static-1.381",
  "integrations-error-boundary-lib": "static-1.14874",
  "integrations-tracking-lib": "static-1.6111",
  "redux-observable": "static-1.79",
  "rxjs": "static-5.10",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4625",
  "ai-settings-ui-library": "static-1.8615",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1615",
  "onboarding-data-sync-lib": "static-1.2859",
  "growth-onboarding-next-action-components": "static-1.3038",
  "user-context-client": "static-1.4998",
  "js-cookie": "static-1.18",
  "academy-service-client": "static-1.4180",
  "croppie": "static-2.10",
  "final-form": "static-1.83",
  "SafeStorage": "static-1.4885",
  "trellis-ecosystem": "static-1.7871",
  "wootric-nps": "static-1.7305",
  "universal-page-editor-lib": "static-1.3501",
  "settings-ui-lib": "static-1.13016",
  "simple-data-table": "static-1.3847",
  "meetings-connect-utils-lib": "static-1.8108",
  "crm-record-cards-client": "static-1.85"
},
  depPathPrefixes: {
  "payments-ui-app": "/payments-ui-app/static-1.28730",
  "bend-plugin-arboretum": "/bend-plugin-arboretum/static-1.2034",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.512",
  "crm_data": "/crm_data/static-4.93233",
  "data-fetching-client": "/data-fetching-client/static-1.10127",
  "emoji-mart": "/emoji-mart/static-3.7",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8771",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1796",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6080",
  "hs-test-utils": "/hs-test-utils/static-1.8527",
  "hub-http": "/hub-http/static-1.6694",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11975",
  "I18n": "/I18n/static-7.1709",
  "jasmine-runner": "/jasmine-runner/static-1.6941",
  "quartz": "/quartz/static-1.7683",
  "raven": "/raven/static-3.5925",
  "react-dlb": "/react-dlb/static-1.94",
  "react-dnd": "/react-dnd/static-2.33",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "react-stripe-js": "/react-stripe-js/static-1.121",
  "react-utils": "/react-utils/static-2.5667",
  "reselect": "/reselect/static-3.16",
  "stripe-js": "/stripe-js/static-1.120",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6112",
  "UIComponents": "/UIComponents/static-3.8921",
  "usage-tracker-public": "/usage-tracker-public/static-1.7622",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38080",
  "payments-checkout-lib": "/payments-checkout-lib/static-1.653",
  "cssUtils": "/cssUtils/static-1.1111",
  "customer-data-objects": "/customer-data-objects/static-1.8195",
  "FireAlarmUi": "/FireAlarmUi/static-1.4878",
  "foundations-assets": "/foundations-assets/static-1.5376",
  "foundations-theming": "/foundations-theming/static-1.4978",
  "graphql": "/graphql/static-1.93",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12282",
  "icons": "/icons/static-2.704",
  "isMobile": "/isMobile/static-1.7",
  "metrics-js": "/metrics-js/static-1.9990",
  "PatternValidationJS": "/PatternValidationJS/static-1.3372",
  "property-translator": "/property-translator/static-1.5868",
  "quartz-config": "/quartz-config/static-1.1461",
  "quartz-core": "/quartz-core/static-1.6902",
  "quartz-i18n": "/quartz-i18n/static-1.1358",
  "quartz-routing": "/quartz-routing/static-1.1113",
  "quartz-tracking": "/quartz-tracking/static-1.1062",
  "react": "/react/static-7.203",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17227",
  "react-select-plus": "/react-select-plus/static-1.118",
  "react-virtualized": "/react-virtualized/static-2.112",
  "redux": "/redux/static-4.81",
  "redux-thunk": "/redux-thunk/static-2.84",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "ReduxMessenger": "/ReduxMessenger/static-2.10858",
  "rpc-client-utils": "/rpc-client-utils/static-1.5157",
  "sanitize-text": "/sanitize-text/static-1.8646",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.188",
  "styled-components": "/styled-components/static-2.100",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "superstore": "/superstore/static-1.5247",
  "transmute": "/transmute/static-2.97",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11633",
  "ui-images": "/ui-images/static-2.1278",
  "usage-tracker-core": "/usage-tracker-core/static-1.7661",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3960",
  "quartz-webpack": "/quartz-webpack/static-1.3907",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.761",
  "bender-build-tools": "/bender-build-tools/static-1.3604",
  "crm_universal": "/crm_universal/static-1.22747",
  "customer-data-email": "/customer-data-email/static-1.18663",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10320",
  "dispatcher": "/dispatcher/static-1.148",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8410",
  "general-store": "/general-store/static-6.20",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8251",
  "quick-fetch": "/quick-fetch/static-1.4238",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5040",
  "floating-ui": "/floating-ui/static-1.68",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2694",
  "framer-motion": "/framer-motion/static-1.84",
  "hs-story-utils": "/hs-story-utils/static-1.9917",
  "react-aria": "/react-aria/static-1.77",
  "react-create-root-preference": "/react-create-root-preference/static-1.105",
  "tanstack-table": "/tanstack-table/static-1.66",
  "trellis-assets": "/trellis-assets/static-1.3122",
  "ui-fonts": "/ui-fonts/static-1.1237",
  "HeadJS": "/HeadJS/static-2.824",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3638",
  "msw": "/msw/static-1.103",
  "msw-config": "/msw-config/static-1.30",
  "testing-library": "/testing-library/static-1.165",
  "hs-locale-management": "/hs-locale-management/static-1.409",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.235",
  "moment-timezone": "/moment-timezone/static-5.96",
  "jasmine": "/jasmine/static-4.4794",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6254",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5237",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20519",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19597",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11346",
  "crm-message-bus": "/crm-message-bus/static-1.44137",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13524",
  "customer-data-properties": "/customer-data-properties/static-1.53097",
  "growth-payments-core": "/growth-payments-core/static-1.26527",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9566",
  "usage-tracker": "/usage-tracker/static-1.7811",
  "usage-tracker-container": "/usage-tracker-container/static-1.7801",
  "sassPrefix": "/sassPrefix/static-1.376",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4158",
  "foundations-theming-base": "/foundations-theming-base/static-1.3963",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3461",
  "stylex": "/stylex/static-1.46",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.279",
  "hub-http-janus": "/hub-http-janus/static-1.908",
  "hubspotter-http": "/hubspotter-http/static-1.4982",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.607",
  "module-federation": "/module-federation/static-1.39",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.654",
  "quartz-auth": "/quartz-auth/static-1.1358",
  "quartz-head": "/quartz-head/static-1.1348",
  "quartz-test": "/quartz-test/static-1.1358",
  "trellis-components": "/trellis-components/static-1.3141",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5497",
  "csstype": "/csstype/static-1.50",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.188",
  "web-vitals": "/web-vitals/static-1.19",
  "immer": "/immer/static-1.105",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.567",
  "chirp-fetch": "/chirp-fetch/static-1.2393",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4963",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5202",
  "sequences-lib": "/sequences-lib/static-1.8809",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5077",
  "FileManagerCore": "/FileManagerCore/static-1.40361",
  "FileManagerLib": "/FileManagerLib/static-1.40502",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5371",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "salesImages": "/salesImages/static-1.746",
  "timezone-utils": "/timezone-utils/static-2.5719",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10656",
  "react-dnd-compat": "/react-dnd-compat/static-1.5098",
  "stylex-utils": "/stylex-utils/static-1.176",
  "trellis-theming": "/trellis-theming/static-1.1502",
  "react-flip-move": "/react-flip-move/static-1.83",
  "avatar-components": "/avatar-components/static-1.2975",
  "hs-resources": "/hs-resources/static-1.672",
  "pulse": "/pulse/static-1.1137",
  "utility-belt": "/utility-belt/static-1.3026",
  "zustand": "/zustand/static-1.89",
  "batch-promise": "/batch-promise/static-1.2037",
  "customer-data-associations": "/customer-data-associations/static-1.7826",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8540",
  "customer-data-tracking": "/customer-data-tracking/static-1.7360",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7381",
  "framework-data-table": "/framework-data-table/static-2.12862",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50083",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24241",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8268",
  "ui-addon-opt": "/ui-addon-opt/static-4.8902",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10048",
  "customer-data-rte": "/customer-data-rte/static-1.33925",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "file-manager-components": "/file-manager-components/static-1.24862",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3546",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6555",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19306",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15866",
  "payment-link-components": "/payment-link-components/static-1.24482",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5594",
  "prosemirror": "/prosemirror/static-1.13",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39195",
  "react-colorpicker": "/react-colorpicker/static-2.10698",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18554",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9111",
  "user-context": "/user-context/static-1.5542",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2053",
  "atom": "/atom/static-1.5560",
  "reference-resolvers": "/reference-resolvers/static-1.8673",
  "calling-global-api": "/calling-global-api/static-1.66230",
  "calling-internal-common": "/calling-internal-common/static-1.31813",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67612",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59904",
  "commerce-products-lib": "/commerce-products-lib/static-1.10944",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4120",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4777",
  "crm-links": "/crm-links/static-1.6801",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4451",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10253",
  "data-agent-utils": "/data-agent-utils/static-1.955",
  "external-options-client-types": "/external-options-client-types/static-1.4446",
  "formula-editor": "/formula-editor/static-1.15028",
  "google-libphonenumber": "/google-libphonenumber/static-1.50",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3782",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4522",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1120",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4015",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4290",
  "property-value-citations": "/property-value-citations/static-1.3711",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8601",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.511",
  "tiered-pricing": "/tiered-pricing/static-1.2306",
  "topics-actions-lib": "/topics-actions-lib/static-1.672",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1408",
  "trial-components-library": "/trial-components-library/static-1.14404",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11348",
  "laboratory-lib": "/laboratory-lib/static-3.7635",
  "onboarding-scopes": "/onboarding-scopes/static-1.6942",
  "seat-types-lib": "/seat-types-lib/static-1.1071",
  "magpie-lib": "/magpie-lib/static-1.5918",
  "navigation-messaging": "/navigation-messaging/static-1.8524",
  "ts-schema": "/ts-schema/static-1.4402",
  "opentelemetry-web": "/opentelemetry-web/static-1.23",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10926",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10924",
  "base-ui": "/base-ui/static-1.29",
  "react-day-picker": "/react-day-picker/static-1.15",
  "tanstack-virtual": "/tanstack-virtual/static-1.43",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8666",
  "audio-components": "/audio-components/static-1.6592",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1028",
  "ContentUtils": "/ContentUtils/static-1.69507",
  "copilot-toolkit": "/copilot-toolkit/static-1.12177",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.30081",
  "FileManagerImages": "/FileManagerImages/static-1.38013",
  "html-to-image": "/html-to-image/static-1.65",
  "immerable": "/immerable/static-1.4630",
  "ui-universal-auth": "/ui-universal-auth/static-1.9768",
  "urlinator": "/urlinator/static-1.5002",
  "video-components": "/video-components/static-1.14470",
  "video-data-lib": "/video-data-lib/static-1.36126",
  "video-embed": "/video-embed/static-1.36960",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.830",
  "trellis-migration-context": "/trellis-migration-context/static-1.69",
  "event-emitter": "/event-emitter/static-1.1450",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.500",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4342",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.640",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7286",
  "persist-promise": "/persist-promise/static-1.4194",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13662",
  "reporting-data": "/reporting-data/static-1.69400",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.459",
  "purchase-motions-components": "/purchase-motions-components/static-1.6650",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7069",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5572",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19582",
  "onboarding-tours": "/onboarding-tours/static-1.17411",
  "stripe-connect-js": "/stripe-connect-js/static-1.83",
  "chatspot-core": "/chatspot-core/static-1.23966",
  "content-assistance-lib": "/content-assistance-lib/static-1.8442",
  "draft-content-plugins": "/draft-content-plugins/static-1.29179",
  "draft-convert": "/draft-convert/static-2.84",
  "draft-extend": "/draft-extend/static-3.88",
  "draft-js": "/draft-js/static-5.90",
  "draft-plugins": "/draft-plugins/static-2.22380",
  "rich-text-lib": "/rich-text-lib/static-1.20576",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2233",
  "poll-commands": "/poll-commands/static-1.3966",
  "video-components-external": "/video-components-external/static-1.12468",
  "trellis-story-utils": "/trellis-story-utils/static-1.4986",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10013",
  "content-media-capture": "/content-media-capture/static-1.5817",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10351",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9585",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10768",
  "hub-http-contrib": "/hub-http-contrib/static-1.3521",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5690",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6881",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19589",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4009",
  "merchandise-lib": "/merchandise-lib/static-1.286",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18707",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1478",
  "calling-error-reporting": "/calling-error-reporting/static-1.31820",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11532",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7029",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7609",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2492",
  "commerce-permissions": "/commerce-permissions/static-1.1274",
  "products-iframe-lib": "/products-iframe-lib/static-1.8942",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11308",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6936",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11009",
  "sales-views-client-types": "/sales-views-client-types/static-1.4747",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10446",
  "data-agent-kit": "/data-agent-kit/static-1.942",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.257",
  "fsm": "/fsm/static-1.4246",
  "markdown-it": "/markdown-it/static-1.6",
  "policy-lib": "/policy-lib/static-1.7292",
  "bark-lib": "/bark-lib/static-1.17022",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.106",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6385",
  "react-codemirror": "/react-codemirror/static-1.11130",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16043",
  "hubs-service-types": "/hubs-service-types/static-1.1756",
  "navigation-components": "/navigation-components/static-1.19197",
  "nest": "/nest/static-1.724",
  "nudge-client-utils": "/nudge-client-utils/static-1.3444",
  "purchase-motions-api": "/purchase-motions-api/static-1.6653",
  "signup-constants": "/signup-constants/static-1.19970",
  "idb-keyval": "/idb-keyval/static-1.55",
  "magpie-types": "/magpie-types/static-1.5378",
  "reactive-lib": "/reactive-lib/static-1.1209",
  "simple-logging-lib": "/simple-logging-lib/static-1.3539",
  "nav-meta": "/nav-meta/static-1.30834",
  "breeze-engine-core": "/breeze-engine-core/static-1.1511",
  "cms-field-types": "/cms-field-types/static-1.5298",
  "content-icons-ui": "/content-icons-ui/static-1.2470",
  "integrations-lib": "/integrations-lib/static-1.17459",
  "underscore": "/underscore/static-1.8",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.332",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1564",
  "social-insights-client-types": "/social-insights-client-types/static-1.22954",
  "outpost": "/outpost/static-1.4617",
  "reporting-client-types": "/reporting-client-types/static-1.2848",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8526",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11029",
  "immutable-less": "/immutable-less/static-1.5140",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18457",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21050",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8442",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4403",
  "growth-data-modal": "/growth-data-modal/static-1.6155",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3010",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5626",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8149",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29597",
  "data-token-picker": "/data-token-picker/static-1.17156",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1211",
  "highlight.js": "/highlight.js/static-1.90",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13621",
  "content-media-compositions": "/content-media-compositions/static-2.17628",
  "media-bridge-lib": "/media-bridge-lib/static-1.19662",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4917",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37269",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "highcharts": "/highcharts/static-8.115",
  "storybook-react": "/storybook-react/static-1.44",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16692",
  "browser-eslint": "/browser-eslint/static-2.57",
  "academy-common-lib": "/academy-common-lib/static-1.15504",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3201",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3520",
  "whisper-core-api": "/whisper-core-api/static-1.7663",
  "flux-actions": "/flux-actions/static-1.381",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14874",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6111",
  "redux-observable": "/redux-observable/static-1.79",
  "rxjs": "/rxjs/static-5.10",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4625",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8615",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1615",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2859",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3038",
  "user-context-client": "/user-context-client/static-1.4998",
  "js-cookie": "/js-cookie/static-1.18",
  "academy-service-client": "/academy-service-client/static-1.4180",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.83",
  "SafeStorage": "/SafeStorage/static-1.4885",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7871",
  "wootric-nps": "/wootric-nps/static-1.7305",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3501",
  "settings-ui-lib": "/settings-ui-lib/static-1.13016",
  "simple-data-table": "/simple-data-table/static-1.3847",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8108",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.85"
}
};
